import { alpha, Theme } from '@mui/material/styles';

export default function Backdrop(theme: Theme) {
  return {
    MuiBackdrop: {
      styleOverrides: {
        root: {
          backgroundColor: 'transparent',
        },
        invisible: {
          background: 'transparent',
        },
      },
    },
  };
}
